var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 725.5 219.9",
    style: {
      enableBackground: "new 0 0 725.5 219.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#080707;}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:#070606;}\r\n\t.st4{fill:#0F0F0F;}\r\n\t.st5{fill:#231F20;}\r\n\t.st6{fill:url(#SVGID_3_);}\r\n\t.st7{fill:url(#SVGID_4_);}\r\n\t.st8{fill:url(#SVGID_5_);}\r\n\t.st9{fill:#190909;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.589,
    y1: 61.9008,
    x2: 725.5201,
    y2: 61.9008,
    gradientTransform: "matrix(1 0 0 -1 0 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#658EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#5373A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#2E3D53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#171C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F0F0F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M572.7,180.5c-1.8-2.5-3.3-5-4.2-7.8c-1.1-3.5-0.9-7.1-0.3-10.6c0.5-2.8,1.3-5.6,2.8-8c2.4-4,6-6.5,10.4-8 c4.7-1.5,9.5-1.7,14.3-1.2c3,0.3,5.9,1.1,8.5,2.4c4.5,2.3,7.4,6,9.1,10.6c1.8,4.9,2.4,9.9,0.9,15c-0.7,2.5-2.2,4.7-3.6,6.9 c-0.1,0.2-0.3,0.4-0.4,0.5c0.2,0.3,0.5,0.2,0.8,0.2c16.8,0,33.7,0,50.5,0c16.5,0,33,0,49.4,0c0.9,0,1.1-0.2,1.1-1.1 c-0.1-3.7,0.1-7.4-0.2-11.1c-0.2-2.1-0.6-4.1-1.8-5.8c-1.5-2.1-3.6-3-6-3.4c-4.1-0.8-8.2-0.4-12.2-0.1c-3.6,0.3-7.1,1-10.6,1.7 c-2.9,0.6-5-0.8-5.7-3.7c-0.5-2.3-1-4.5-1.5-6.8c-0.1-0.5-0.1-0.7,0.5-0.8c6.2-1.5,12.4-2.6,18.7-3.2c4.2-0.4,8.3-0.4,12.5,0 c3.7,0.4,7.4,1.3,10.7,3.2c4.4,2.6,6.8,6.6,8,11.4c0.9,3.6,1.2,7.2,1.2,10.8c0,3.8,0,7.5,0,11.2c0,1.6-0.3,3.2-0.8,4.7 c-1.1,3.3-3.3,5.1-6.7,5.7c-1.5,0.3-2.9,0.4-4.4,0.4c-65.8,0-131.6,0-197.5,0c-4.1,0-7.9-1.4-11.4-3.5c-0.7-0.4-1.1-0.4-1.8,0 c-3.6,2.3-7.5,3.4-11.9,3.4c-19.2,0-38.3,0-57.5,0c-0.7,0-1-0.1-0.9-0.9c0-2.5,0-5,0-7.5c0-2.6,1.2-4.2,3.3-4.6 c0.7-0.1,1.4-0.2,2.1-0.2c0.8,0.1,1-0.2,1-1c0-15.6,0-31.1,0-46.7c0-0.9,0-1.9,0.2-2.8c0.4-1.7,1.7-2.9,3.4-3.2 c2.4-0.4,4.8-0.1,7.3-0.2c0.9,0,2-0.3,2.5,0.1c0.6,0.5,0.2,1.7,0.2,2.6c0,7.1,0,14.2,0,21.4c0,0.7,0.1,1,0.9,0.8 c6.1-1,12.2-2,18.3-2.9s12.2-2,18.3-2.9c4.5-0.6,8.6,0.8,12.4,3.3c6.2,4.2,9.1,10.2,9.6,17.6c0.3,4.3,0,8.6-1.3,12.8 c-0.2,0.7,0,1.1,0.8,1.1c0.5,0,1,0,1.5,0c14.7,0,29.4,0,44.1,0c4.8,0,9.6,0,14.4,0C572,180.5,572.3,180.5,572.7,180.5L572.7,180.5z  M471.6,180.5C471.6,180.5,471.6,180.5,471.6,180.5c6,0,11.9,0.1,17.9-0.1c5.5-0.1,9.2-3.9,9.6-8.7c0.3-3.7-0.1-7.2-2.6-10.1 c-1.9-2.3-4.5-3.4-7.5-2.9c-3.7,0.5-7.4,1.2-11.1,1.9c-8.1,1.4-16.2,2.8-24.3,4.1c-0.8,0.1-0.9,0.4-0.9,1.1c0,4.6,0,9.2,0,13.8 c0,0.7,0.2,0.9,0.9,0.9C459.5,180.5,465.5,180.5,471.6,180.5L471.6,180.5z M602,167.3c0-2.5-0.7-4.8-2.3-6.7 c-2.5-2.9-5.8-3.8-9.4-3.5c-2.1,0.1-4.2,0.5-5.9,1.9c-3.7,3.1-5.3,10.6-0.6,15.4c2.2,2.3,4.7,4.1,7.4,5.8c0.3,0.2,0.6,0.2,0.9,0 c2.9-1.9,5.7-4,7.7-6.8C601,171.6,602,169.6,602,167.3L602,167.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M655.7,211.7c0,0.4,0,0.8,0,1.2c0,1.4,0,1.3-1.3,1.6c-7.5,1.4-15.1,2.7-22.6,4.1c-2.4,0.4-4.9,0.9-7.3,1.3 c-2.1,0.4-3.7-1.1-3.8-3.2c0-1,0-2.1,0-3.1c0-0.5,0.1-0.7,0.7-0.8c5.5-1,11-2,16.5-3c4.7-0.9,9.5-1.7,14.2-2.6 c2.2-0.4,3.6,0.6,3.6,2.9C655.8,210.6,655.7,211.1,655.7,211.7L655.7,211.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 459.4199,
    y1: 90.4246,
    x2: 475.4101,
    y2: 90.4246,
    gradientTransform: "matrix(1 0 0 -1 0 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#658EC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#5373A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#2E3D53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#171C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F0F0F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M459.4,131.4c0-4.4,3.6-7.9,8-7.8c4.4,0,8,3.6,8,7.9c0,4.5-3.7,8.1-8.1,8.1 C462.9,139.5,459.4,135.9,459.4,131.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M599.6,127.3c-0.1,4.6-3.8,8.1-8.3,7.9c-4.5-0.1-7.8-3.8-7.6-8.4c0.1-4.1,3.5-7.6,8-7.5 C596.2,119.3,599.7,123,599.6,127.3L599.6,127.3z"
  }))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M499.2,0v85.4c0,3.7-1.9,5.6-5.6,5.6h-9.7V50.7h-37.2v34.7c0,3.7-1.8,5.6-5.5,5.6h-9.8V6.2 c0-4.1,1.9-6.2,5.6-6.2h9.7v35.4h37.2V5.5c0-3.7,1.7-5.5,5.2-5.5H499.2L499.2,0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M561.2,51.4c0,3.5-0.5,6.5-1.6,8.9c-1,2.4-2.5,4.2-4.3,5.5s-4,2.2-6.6,2.7c-2.5,0.6-5.4,0.8-8.5,0.8h-16 c0.7,3.5,2.4,5.9,4.9,7.2s5.5,2,8.9,2c2.9,0,5.2-0.3,7-0.8s3.8-1.3,6.2-2.2c1.8-0.6,3.2-0.4,4.2,0.3c1,0.8,1.4,2,1.4,3.8v8.1 c-1.9,0.8-3.8,1.5-5.8,2.1c-2,0.6-4.1,1.1-6.4,1.5c-2.3,0.4-4.6,0.6-7,0.6c-2.7,0-5.6-0.3-9-1c-3.3-0.7-6.5-2-9.4-4 s-5.5-4.9-7.5-8.6c-2-3.7-3.1-8.8-3.1-15.2c0-7.8,1-13.7,3.1-17.8c2.1-4.2,4.6-7.3,7.6-9.5s6.1-3.6,9.3-4.2c3.2-0.6,6-1,8.3-1 c2.5,0,5.1,0.4,7.9,1.1c2.8,0.7,5.5,1.9,7.9,3.6s4.4,3.8,6,6.5C560.4,44.3,561.2,47.6,561.2,51.4L561.2,51.4z M536.5,56.5 c4.3,0,7.3-0.3,8.9-0.9c1.6-0.6,2.5-1.8,2.5-3.8c0-2.7-1-4.8-2.9-6.4c-2-1.5-4.5-2.3-7.7-2.3c-2.3,0-4.2,0.4-5.9,1.1 s-3,1.7-4.1,2.9c-1.1,1.2-2,2.5-2.6,4c-0.6,1.4-1.1,3.2-1.4,5.3L536.5,56.5L536.5,56.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 570.9036,
    y1: 180.2625,
    x2: 607.4879,
    y2: 171.1414,
    gradientTransform: "matrix(1 0 0 -1 0 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#0F1010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#131417"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#181C23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#202834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2A374A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#374A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#466086"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#5679AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#658EC9"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M600.5,3.2c2.6,0,5.4,0.3,8.3,0.8c2.9,0.5,5.3,1,7.1,1.5c-0.2,2.7-0.4,4.7-0.5,5.7c-0.2,1.1-0.5,2.3-0.8,3.6 c-0.5,1.8-1.2,3-2,3.4s-2.4,0.4-4.7-0.1c-0.7-0.2-1.7-0.3-2.9-0.4c-1.2-0.1-2.3-0.1-3.3-0.1c-2.1,0-4,0.4-5.7,1.2 c-1.7,0.8-2.5,2.3-2.5,4.6v8.2h16.4V40c0,3.7-1.8,5.6-5.5,5.6h-10.9v39.9c0,3.7-1.8,5.5-5.5,5.5h-9.8V45.7h-5.9v-8.3 c0-3.9,2-5.9,5.9-5.9V20.6c0-3.4,0.6-6.2,1.9-8.4c1.3-2.2,3-4,5.2-5.4s4.6-2.3,7.2-2.9S597.7,3.1,600.5,3.2L600.5,3.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.858,
    y1: 129.9008,
    x2: 635.4462,
    y2: 209.909,
    gradientTransform: "matrix(1 0 0 -1 0 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#131518"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#202833"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#35465F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#526F9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6388BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#658EC9"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M639,46.3v26.4c0,1.9,0.5,3.2,1.6,3.9c1.1,0.7,3,1,5.6,1c1,0,2-0.1,2.9-0.2s2.2-0.3,3.8-0.6 c1.9-0.4,3.3-0.2,4,0.6c0.8,0.8,1.2,2.1,1.2,4v7c-0.9,0.7-2.7,1.5-5.3,2.3c-2.7,0.8-5.7,1.2-9.2,1.2c-2.2,0-4.5-0.3-6.9-1 c-2.4-0.6-4.6-1.7-6.5-3.2s-3.5-3.3-4.7-5.7s-1.8-5.2-1.8-8.5V14.6l9.3-2.2c0.5-0.1,1-0.2,1.7-0.3s1.3,0,2,0.2 c0.6,0.2,1.2,0.7,1.6,1.4c0.5,0.7,0.7,1.8,0.7,3.4v14.4h16.8v9.2c0,3.8-1.8,5.7-5.3,5.7L639,46.3L639,46.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.2823,
    y1: 181.2119,
    x2: 728.8799,
    y2: 160.9697,
    gradientTransform: "matrix(1 0 0 -1 0 222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#1D232D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#2D3C51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#3C5272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#49658D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#5374A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#5B80B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#6088C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#648CC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#658EC9"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M697.9,31.4c8.2,0,14.2,1.8,17.9,5.3c3.7,3.5,5.6,8.5,5.6,15v34c0,3.6-1.7,5.3-5.1,5.3h-10.3V51.4 c0-4.6-2.7-6.8-8.2-6.8c-2.4,0-4.6,0.2-6.8,0.6s-4.1,1-6,1.7v38.5c0,3.7-1.6,5.6-4.8,5.6h-10.5V0.3h9.3c4,0,6,2,6,6v27.3 c2-0.7,4.1-1.3,6.4-1.6C693.8,31.6,695.9,31.4,697.9,31.4L697.9,31.4z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M293.4,187.1c-3.7,0.1-5.5-1.7-7.5-2.8c-5.3-3-9.8-1.9-13.5,3.2c-4.5,6.2-9.1,12.3-13.7,18.5 c0.1-10.7-0.3-21.4,0.1-32.1c0.2-5.2-1.5-8.7-5.8-11.9c-15.8-12.1-31.3-24.6-46.8-37c-1.6-1.3-3.2-2.6-5-3.8 c-0.6-0.4-1.8-0.6-2.4-0.3c-1.3,0.6-1.3,1.9-0.7,3c1.1,2.1,2.4,4.1,3.7,6.1c10.4,15.9,20.7,31.8,31.1,47.7 c-3.5,3.5-7.9,4.6-11.9,6.4c-21,9.7-42.1,19.1-63,29c-9.7,4.6-17.9,3.9-26.3-2.9C90.7,177.5,49.4,145,8.2,112.3 c-0.5-0.4-0.9-0.7-1.4-1.1c-6.8-5.7-6.6-7.8,1.7-11.6C62.7,74.8,116.9,50,171.1,25.2c13.5-6.2,27-12.2,40.4-18.6 c9.3-4.4,17.4-3.7,25.6,2.9c41.3,33,82.8,65.7,124.2,98.5c0.9,0.7,1.9,1.4,2.8,2.3c4.4,4.1,4.2,6.6-1.4,9.3 c-13.1,6.2-26.4,12.1-39.6,18.2c-7.8,3.6-15.5,7.5-23.5,10.6c-5,1.9-6.5,4.9-6.3,10C293.7,167.8,293.4,177.2,293.4,187.1 L293.4,187.1z M196.8,118c-0.2,0.2-0.6,0.4-0.6,0.6c0.1,0.4,0.4,0.8,0.6,1.2c0.2-0.2,0.6-0.4,0.6-0.6 C197.3,118.8,197,118.4,196.8,118z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.e6e91fc3c00b405e11d2db69f39ebb37.svg";
export { ForwardRef as ReactComponent };